import React, { useEffect, useState, memo } from 'react';
import AxiosServices from '../../services/AxiosServices';
import Loader from '../../ui/Loader';
import Modal from '../../ui/Modal';
import Singleton from '../../core/singleton';
import events from '../../core/events';
import uniqBy from 'lodash.uniqby';
import Fuse from 'fuse.js';
import { ProductsList } from './ProductsList';
import { ShopSelector } from './ShopSelector';
import { ErrorJumbotron } from '../../ui/ErrorJumbotron';
import StockSelector from '../../ui/StockSelector';

const Inventory = () => {
    const { getTradByKey, eventEmitter } = Singleton.getInstance();
    const [shops, setShops] = useState([]);
    const [displayedShopProducts, setDisplayedShopProducts] = useState([]);
    const [searchCriteria, setSearchCriteria] = useState('');
    const [shopPoducts, setShopPoducts] = useState([]);
    const [fuse, setFuse] = useState(null);
    const [currentShop, setCurrentShop] = useState({ uuid: "", status: null });
    const [pending, setPending] = useState(false);
    const [shopInvalibityMessage, showShopInvalibityMessage] = useState(false);
    const [stockModalVisibility, setStockModalVisibility] = useState(false);
    const [stockModalProduct, setStockModalProduct] = useState(null);
    const [displayMode, setDisplayMode] = useState('list');
    /** show the selected shop */
    const showShopProducts = shop => {
        setPending(true);
        const { uuid } = shop;
        setCurrentShop(shop);
        setSearchCriteria('');
        let input = document.querySelector('.inventorySearchInput');
        (input !== null) ? input.value = "" : null;
        AxiosServices.productsByShop(uuid).then((result) => {
            let { data } = result;
            let s = uniqBy(data, 'retail_product_uuid').map(e => e.retail_product_uuid).toString().split(',');
            AxiosServices.stock(uuid, s).then((result) => {
                let mapppedProductsWithStocks = data.map((product) => {
                    let s = result.data.find((p) => (p.retail_product_uuid === product.retail_product_uuid));
                    product.stock = (typeof (s) !== "undefined") ? s : { quantity: null };
                    return product;
                });
                setFuse(new Fuse(mapppedProductsWithStocks, {
                    keys: ['brand', 'title', 'categories'],
                    shouldSort: true,
                    threshold: 0.6,
                    location: 0,
                    distance: 100,
                    maxPatternLength: 32,
                    minMatchCharLength: 1,
                }));
                setDisplayedShopProducts(mapppedProductsWithStocks);
                setShopPoducts(mapppedProductsWithStocks);
                setPending(false);
            })
        });
    }
    /** get a list of all the shops*/
    const getShopsList = () => {
        setPending(true);
        AxiosServices.shops()
            .then(shops => {
                let t = shops.data.filter(shop => (shop.status === "closed" || shop.status === "display_only"))
                setShops(t);
                //console.log(t);
                if (currentShop.status === null) showShopProducts(t[0]);
                else showShopProducts(currentShop);
                if (t.length === 0) {
                    showShopInvalibityMessage(true);
                }
                setPending(false);
            })
            .catch(error => {
                (error.response.status === 401) &&
                    eventEmitter.emit(events.ON_USER_LOGOUT);
            })
    }
    /** perform a search based on the criteria via fuse*/
    const fuseSearch = searchCriteria => {
        let propositions = fuse.search(searchCriteria);
        setSearchCriteria(searchCriteria);
        if (propositions.length > 0) {
            setDisplayedShopProducts(propositions)
        } else {
            if (searchCriteria === '') {
                setDisplayedShopProducts(shopPoducts);
            } else {
                setDisplayedShopProducts([]);
            }
        }
    }
    /** just set the initial value for the search engine*/
    const setSearchValue = (searchCriteria) => {
        let input = document.querySelector('.inventorySearchInput')
        input.value = searchCriteria;
        fuseSearch(searchCriteria);
    }
    /** if the searchcriteria is not empty perform a search */
    const eraseOrSearch = () => {
        if (searchCriteria !== "") {
            document.querySelector('.inventorySearchInput').value = "";
            setSearchCriteria('');
            setDisplayedShopProducts(shopPoducts);
        }
    }
    /** toggle the modal with a product as param */
    const editAndShowStockOf = product => {
        setStockModalProduct(product);
        setStockModalVisibility(true);
    }
    /** switch to a listView */
    const ViewModeSelector = () => (displayedShopProducts.length > 0) ? <div className="btn-group position-absolute" >
        <button onClick={() => setDisplayMode('list')} className={`btn btn-outline-dark btn-sm ${(displayMode === 'list') ? 'active' : ''}`}><i className="far fa-list-alt"></i></button>
        <button onClick={() => setDisplayMode('grid')} className={`btn btn-outline-dark btn-sm ${(displayMode === 'grid') ? 'active' : ''}`}><i className="fas fa-grip-horizontal"></i></button>
    </div> : null
    /** component did mount like */
    useEffect(() => getShopsList(), []);
    return <div className="container-fluid">
        {
            (pending) &&
            <Loader />
        }
        <div className="">
            <ViewModeSelector />
            <h4 className="text-center text-md-right form-group">{getTradByKey('manage_inventory')}</h4>
            <ShopSelector shops={shops} currentShop={currentShop} showShopProducts={showShopProducts} />
            {
                ((shops.length > 0) && (currentShop.status !== "open")) &&
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control inventorySearchInput"
                        placeholder={`${currentShop.uuid} ${getTradByKey('looking_for_something')} `}
                        onChange={e => fuseSearch(e.target.value)}
                        aria-describedby="button-addon2" />
                    <div className="input-group-append">
                        <button className="btn btn-outline-primary" type="button" onClick={() => eraseOrSearch()}>
                            <i className={`width-16px fas fa-${(searchCriteria === "") ? 'search' : 'times'}`}></i>
                        </button>
                    </div>
                </div>
            }
        </div>
        {
            ((currentShop.status !== "open") && (!pending)) &&
            <ProductsList
                displayMode={displayMode}
                searchCriteria={searchCriteria}
                editAndShowStockOf={editAndShowStockOf}
                displayedShopProducts={displayedShopProducts}
                setSearchValue={setSearchValue} />
        }
        {
            (currentShop.status === "open") &&
            <ErrorJumbotron message={getTradByKey('can_not_manage_inventory')} />
        }
        {
            (shopInvalibityMessage) &&
            <ErrorJumbotron message={getTradByKey('no_shops_for_the_moment')} />
        }
        {
            (stockModalVisibility) &&
            <Modal onClose={() => setStockModalVisibility(false)}>
                <StockSelector onStockUpdate={() => getShopsList()} onClose={() => setStockModalVisibility(false)} product={stockModalProduct} />
            </Modal>
        }
    </div >
}
export default memo(Inventory)